import { Injectable } from '@angular/core';
import { WeekColorResponseModel } from '../models/response-models/week-color-response.model';

@Injectable({
  providedIn: 'root',
})
export class TpmItemsProcessorService {
  extractProductName(path: string | null | undefined): string {
    const safeName = path ?? '';
    if (!safeName.includes('/')) {
      return safeName;
    }
    const parts = safeName.split('/').map((s) => s.trim());
    const dept = parts[0] || 'N/A';
    const cat = parts[1] || 'N/A';
    const sub = parts[2];
    return sub && sub !== 'NA' ? `${dept} / ${cat} / ${sub}` : `${dept} / ${cat}`;
  }

  getSizeFromProductName(productName: string): string {
    const splitName = productName?.split('/') || [];
    return splitName[5] || 'NA';
  }

  getWeekColorName(id: number, weekColors: WeekColorResponseModel[]): string {
    const weekColor = weekColors.find((wc) => wc.id === id);
    return weekColor ? weekColor.displayName : 'N/A';
  }

  getWeekColorHex(id: number, weekColors: WeekColorResponseModel[]): string {
    const weekColor = weekColors.find((wc) => wc.id === id);
    return weekColor?.color ?? '#ccc';
  }
}
